import { useAppContext } from 'context/AppContext'
import React, { SetStateAction } from 'react'
import { classNames } from 'utils/dom-helpers'
export interface IPagination {
    totalPages: number
    currentPage: number
    setCurrentPage: React.Dispatch<SetStateAction<number>>
    pageSize: number
    setPageSize: React.Dispatch<SetStateAction<number>>
    totalRecords: number
}

const pages = [5, 10, 15, 20, 25, 30, 40, 50]

const Pagination: React.FC<IPagination> = ({
    totalPages,
    pageSize,
    setCurrentPage,
    setPageSize,
    currentPage,
    totalRecords,
}) => {
    const { translations } = useAppContext()

    const buttonClasses = `px-2 py-1 rounded-md border-gray-200 ml-2 hover:border-custom-dark-cyan-blue`
    const disablePrev = currentPage === 0
    const disableNext = currentPage === totalPages - 1

    const startLabel = currentPage * pageSize + 1
    const variable = currentPage == totalPages - 1 ? totalRecords : pageSize
    const endLabel =
        currentPage == totalPages - 1
            ? 0 + variable
            : startLabel - 1 + variable

    const borderStyle = { borderWidth: '1px' } as React.CSSProperties
    return (
        <div className={classNames(
            "flex justify-between ml-2 mr-2 mt-5 items-center text-xs font-medium flex-col lg:flex-row",
            totalPages > 0 ? '' : 'hidden'
        )}>
            <div className="flex items-center mb-4">
                <select
                    style={borderStyle}
                    className="text-gray-900 pr-5 text-xs rounded-md border-gray-300 hover:border-custom-dark-cyan-blue focus:ring-0"
                    onChange={(e) => {
                        setCurrentPage(0)
                        setPageSize(+e.target.value)
                    }}
                    defaultValue={pageSize}
                >
                    {pages.map((page, index) => (
                        <option key={index} value={page}>
                            {translations['view']} &nbsp; {page} &nbsp;
                            {translations['rows']}
                        </option>
                    ))}
                </select>
                <div className="ml-3 text-gray-900">
                    {translations['showing']} &nbsp; {startLabel} -{' '}
                    {endLabel} &nbsp;
                    {translations['of']} &nbsp;{totalRecords}
                </div>
            </div>

            <div>
                <span className='text-gray-900'>{currentPage + 1} &nbsp; {translations['of']} &nbsp;
                {totalPages}</span> 
                <button
                    style={borderStyle}
                    disabled={disablePrev}
                    className={classNames(
                        buttonClasses,
                        disablePrev ? 'bg-gray-300 cursor-not-allowed' : '', "text-gray-900"
                    )}
                    onClick={() => {
                        setCurrentPage((prev) => 0)
                    }}
                >
                    {'<<'}
                </button>
                <button
                    style={borderStyle}
                    disabled={disablePrev}
                    className={classNames(
                        buttonClasses,
                        disablePrev ? 'bg-gray-300 cursor-not-allowed' : '', "text-gray-900"
                    )}
                    onClick={() => {
                        setCurrentPage((prev) => prev - 1)
                    }}
                >
                    {'<'}
                </button>
                {[...Array(totalPages)].map((_, index) => {
                    return (
                        <button
                            style={borderStyle}
                            key={index}
                            onClick={() => setCurrentPage(index)}
                            className={classNames(
                                buttonClasses,
                                index === currentPage
                                    ? 'bg-custom-dark-cyan-blue text-white mb-1'
                                    : '',
                                '',
                                index >= currentPage - 3 &&
                                    index < currentPage + 3
                                    ? ''
                                    : 'hidden', "text-gray-900"
                            )}
                        >
                            {index + 1}
                        </button>
                    )
                })}
                <button
                    style={borderStyle}
                    disabled={disableNext}
                    className={classNames(
                        buttonClasses,
                        disableNext ? 'bg-gray-300 cursor-not-allowed' : '', "text-gray-900"
                    )}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                    {'>'}
                </button>
                <button
                    style={borderStyle}
                    disabled={disableNext}
                    className={classNames(
                        buttonClasses,
                        disableNext ? 'bg-gray-300 cursor-not-allowed' : '', "text-gray-900"
                    )}
                    onClick={() => setCurrentPage((prev) => totalPages - 1)}
                >
                    {'>>'}
                </button>
            </div>
        </div>
    )
}

export default Pagination
